import React from "react";
import "./Home.css";

import { Outlet } from "react-router-dom";
import Sidebar from "../../Components/Sidebar/Sidebar";
import MobileNavbar from "../../Components/Navbar/MobileNavbar";

function Home() {
  return (
    <div className="app-container">
      <div className="main--container">
        <MobileNavbar />
        <Sidebar />
        <Outlet />
      </div>
    </div>
  );
}

export default Home;
